export type Feature =
  | 'dark-theme'
  | 'ads-filters'
  | 'ad-strength'
  | 'unspent-budget-cap'
  | 'acs-suggestions-field'
  | 'team-dashboard-filters'
  | 'spend-unspent-budget-after-end-date'
  | 'ad-pool-bulk-actions'
  | 'google-maps-region-styling-test'
  | 'pulse-check'
  | 'andorra-opt-out';

export type FeatureMap = Record<Feature, boolean>;

// Order "matters"
export const FEATURE_FLAGS: FeatureMap = {
  // Public BETA
  'pulse-check': false,
  // BETA
  'ads-filters': false,
  'unspent-budget-cap': false,
  'acs-suggestions-field': false,
  'andorra-opt-out': false,
  // ALPHA
  'dark-theme': false,
  'ad-strength': false,
  'team-dashboard-filters': false,
  'spend-unspent-budget-after-end-date': false,
  'ad-pool-bulk-actions': false,
  'google-maps-region-styling-test': false,
};

const ALPHA_FEATURES = new Set<Feature>([
  'dark-theme',
  'ad-strength',
  'team-dashboard-filters',
  'spend-unspent-budget-after-end-date',
  'ad-pool-bulk-actions',
  'google-maps-region-styling-test',
]);

export function isAlphaFeature(feature: Feature) {
  return ALPHA_FEATURES.has(feature);
}

const BETA_FEATURES = new Set<Feature>([
  'ads-filters',
  'unspent-budget-cap',
  'acs-suggestions-field',
  'andorra-opt-out',
]);

export function isBetaFeature(feature: Feature) {
  return BETA_FEATURES.has(feature);
}

const PUBLIC_BETA_FEATURES = new Set<Feature>(['pulse-check']);

export function isPublicBetaFeature(feature: Feature) {
  return PUBLIC_BETA_FEATURES.has(feature);
}
